import React, { useState } from 'react';
import { Alert, Button, Card, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { InvoiceIssuerSearch } from '../../components/InvoiceIssuer/InvoiceIssuerSearch';
import { InvoiceIssuerEditor } from '../../components/InvoiceIssuer/InvoiceIssuerEditor';
import { GetInvoiceIssuerDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetInvoiceIssuerDto';
import { CreateUpdateInvoiceIssuerDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/CreateUpdateInvoiceIssuerDto';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import {
  invoiceIssuerData,
  validate,
} from '../../../common/spdCore/contexts/InvoiceIssuerContext';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const InvoiceIssuersView: React.FC = () => {
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [issuer, setIssuer] = useState<GetInvoiceIssuerDto>();

  const handleClose = () => {
    setShow(false);
    setRefresh(!refresh);
  };

  const editIssuer = async (
    issuerU: CreateUpdateInvoiceIssuerDto,
    id?: string,
  ) => {
    const status = await validate(issuerU);
    if (!status.valid) {
      return { saved: false, errors: status.errors };
    }
    try {
      if (id) {
        await spd.invoiceIssuers.update(id, issuerU);
      } else {
        await spd.invoiceIssuers.create(issuerU);
      }
      setShow(false);
      setRefresh(!refresh);
      return {
        saved: true,
        errors: [],
      };
    } catch (response) {
      return {
        saved: false,
        errors: await responseErrors(response as ResponseError),
      };
    }
  };

  const handleAdd = () => {
    setIssuer(undefined);
    setShow(true);
  };

  const onRowClick = async (id: string) => {
    const item = await spd.invoiceIssuers.get(id);
    setIssuer(item);
    setShow(true);
  };

  return (
    <Card>
      <Tabs defaultActiveKey="search" id="invoice-issuers" className="mb-3">
        <Tab eventKey="search" title="Wystawcy faktur" className="m-3">
          <Alert variant="warning">
            Aby dodać nowego wystawcę faktur, należy w trybie serwisowym
            skonfigurować mu dostęp do KSeF oraz powiązanie w systemie. Wymagany
            jest kontakt z administratorem systemu.
          </Alert>
          <InvoiceIssuerSearch
            getData={spd.invoiceIssuers.getAllByPortion}
            getCount={spd.invoiceIssuers.getAllCount}
            refresh={refresh}
            onRowClick={onRowClick}
          />
          <Button
            className="mb-4"
            variant="outline-primary"
            onClick={handleAdd}
          >
            Dodaj
          </Button>
          <InvoiceIssuerEditor
            id={issuer?.id}
            nip={issuer?.nip}
            issuer={invoiceIssuerData(issuer)}
            onCompleted={editIssuer}
            show={show}
            handleClose={handleClose}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
